module.exports = __webpack_public_path__ + "94d9183370b971f90bf0862bee29d60c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/nara-kasbergen.jpg
// module id = 520
// module chunks = 0